"use client";

import type * as React from "react";
import { useState } from "react";
import { BookingConfirmForm } from "@/components/booking/BookingConfirmForm";
import { BookingConfirmSidebar } from "@/components/booking/BookingConfirmSidebar";
import { BookingPriceDetailsModal } from "@/components/booking/BookingPriceDetailsModal";
import { BookingWizard } from "@/components/booking/BookingWizard";
import { useBookingConfirmTotal } from "@/lib/hooks/use-booking-confirm-total";
import { formatAud } from "@/lib/vehicles";

export const BookingStepFour: React.FC = () => {
  const [priceDetailsOpen, setPriceDetailsOpen] = useState(false);

  const {
    bookingTotal,
    priceBreakdown,
    isLoading,
    error,
    refreshTotal,
  } = useBookingConfirmTotal();

  const handlePriceDetailsClick = async () => {
    setPriceDetailsOpen(true);
    await refreshTotal();
  };

  const headerAction = (
    <div className="text-right">
      <p className="text-sm text-gray-600">
        Total:{" "}
        {isLoading ? (
          <span className="inline-block h-6 w-20 animate-pulse rounded bg-gray-200 align-middle" />
        ) : (
          <span className="text-2xl font-bold text-gray-900">
            AU$ {formatAud(bookingTotal ?? 0)}
          </span>
        )}
      </p>
      <button
        type="button"
        onClick={() => void handlePriceDetailsClick()}
        className="cursor-pointer text-sm text-gray-500 underline-offset-2 hover:underline"
      >
        Price details
      </button>
    </div>
  );

  return (
    <BookingWizard step={4} headerAction={headerAction}>
      <div className="px-12 py-6">
        <div className="flex flex-col gap-8 xl:flex-row xl:items-start">
          <div className="min-w-0 flex-1">
            <BookingConfirmForm
              bookingTotal={bookingTotal}
              isTotalLoading={isLoading}
              onPriceDetailsClick={handlePriceDetailsClick}
            />
          </div>

          <BookingConfirmSidebar />
        </div>
      </div>

      <BookingPriceDetailsModal
        open={priceDetailsOpen}
        onClose={() => setPriceDetailsOpen(false)}
        breakdown={priceBreakdown}
        isLoading={isLoading && !priceBreakdown}
        error={error}
      />
    </BookingWizard>
  );
};
